import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
// import CustomInput from '../../components/inputs/CustomInput'
import CustomDialog from '../../components/layouts/common/CustomDialog';
import { CenteredBox } from '../../components/layouts/OneViewBox';
// import { APP_TYPES } from '../../utils/constants';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CustomInput from '../../components/inputs/CustomInputs';

const VersionCreateUi = ({ title, isUpdate, fields, setFields, loading, onSubmit, isModal, handleAreaModalClose }) => {
    return (
        <>
            {!isModal &&
                <CustomDialog
                    id={`${isUpdate ? "edit" : "version"}`}
                    loading={loading}
                    err={fields?.err}
                    onSubmit={onSubmit}
                    title={`${isUpdate ? "Update" : "Create"} ${title}`}
                    closeText="Close"
                    confirmText={`${isUpdate ? "Update" : "Create"}`}
                >
                    {loading ? (
                        <CenteredBox><CircularProgress /></CenteredBox>
                    ) : (
                        <>
                            <CustomInput
                                autoFocus={true}
                                disabled={loading}
                                value={fields?.name}
                                onChange={(e) => setFields({ ...fields, err: '', name: e.target.value })}
                                type="text"
                                label={"Version Name*"}
                            />
                            <CustomInput

                                disabled={loading}
                                value={fields?.main_version}
                                onChange={(e) => setFields({ ...fields, err: '', main_version: e.target.value })}
                                type="text"
                                label={"Main Version*"}
                            />
                            <CustomInput

                                disabled={loading}
                                value={fields?.sub_version}
                                onChange={(e) => setFields({ ...fields, err: '', sub_version: e.target.value })}
                                type="text"
                                label={"Sub Version*"}
                            />
                            <Box>
                          
                                <Box sx={{ minHeight: 250, mt: 2, border: '1px solid #ccc', background: '#fafafa', p: 1 }}>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={fields.description}
                                            disabled={loading}
                                            config={{
                                                placeholder: "Write Version Description...",
                                                toolbar: [
                                                    'heading', 'bold', 'italic', 'link',
                                                    'bulletedList', 'numberedList', 'blockQuote',
                                                    'undo', 'redo'
                                                ]
                                            }}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                setFields({ ...fields, description: data });
                                            }}
                                        />
                                </Box>
                            </Box>
                        </>
                    )}
                </CustomDialog>
            }
        </>
    )
}

export default VersionCreateUi